import { render, staticRenderFns } from "./DvItemCard.vue?vue&type=template&id=1d3f2f34&scoped=true&"
import script from "./DvItemCard.vue?vue&type=script&lang=ts&"
export * from "./DvItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./DvItemCard.vue?vue&type=style&index=0&id=1d3f2f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f2f34",
  null
  
)

export default component.exports